const sortAppliedSchema = {
  type: 'object',
  properties: {
    event_name: { type: 'string', const: 'sort_applied' },
    event_type: { type: 'string', default: 'sort' },
    tealium_event: { type: 'string', default: 'sort_applied' },
    search_filter_applied_category: { type: 'string', const: 'sort' },
    search_filter_applied_value_name: { type: 'string' },
  },
  required: [
    'search_filter_applied_value_name', 'event_name',
  ],
  additionalProperties: true,
};

export default sortAppliedSchema;
